module.exports = __webpack_public_path__ + "static/media/step3.66b0dc9b.gif";